import { BrowserRouter, Route, Routes } from "react-router-dom";
import FooterPagesNavigation from "./components/FooterPagesNavigation";
import Admin from "./pages/Admin";
import Completed from "./pages/forms/Drivers/CompletedDrivers";
import Home from "./pages/Home";
import QuestionsDrivers from "./pages/forms/Drivers/Drivers";
import NotAllowed from "./pages/NotAllowed";
import QuestionRacines from "./pages/forms/Racines/Racines";
import CompletedDrivers from "./pages/forms/Drivers/CompletedDrivers";
import CompletedRacines from "./pages/forms/Racines/CompletedRacines";
import QuestionEnneagramme from "./pages/forms/Enneagramme/Enneagramme";
import CompletedEnneagramme from "./pages/forms/Enneagramme/CompletedEnneagramme";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/form/0" element={<QuestionsDrivers />} />
        <Route path="/form/1" element={<QuestionRacines />} />
        <Route path="/form/2" element={<QuestionEnneagramme />} />
        <Route path="/completed/0" element={<CompletedDrivers />} />
        <Route path="/completed/1" element={<CompletedRacines />} />
        <Route path="/completed/2" element={<CompletedEnneagramme />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/notAllowed" element={<NotAllowed />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
